import script from "./HomeTopCarouselSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeTopCarouselSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./HomeTopCarouselSkeleton.vue?vue&type=style&index=0&id=f8ae9dfc&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8ae9dfc"]])

export default __exports__